import { getJson } from '../../lib/rest';
export const fetchExperiment = (endpoint) => (projectId) => getJson(`${endpoint}?projectId=${projectId}`);
//# sourceMappingURL=index.js.map